
import { Vue, Prop, Component } from "vue-property-decorator";
import ExpModel from "@/models/ExpModel";

@Component
export default class ExpCarousel extends Vue {
    @Prop({ required: true }) items!: ExpModel[];
    // size of the centered (biggest) card, in px
    @Prop({ default: 150 }) size!: number;
    @Prop({ default: false }) disabled!: boolean;
    // whether the article panel is open (flips the arrow)
    @Prop({ default: false }) open!: boolean;


    // how big / how far from center a card is at distance 0, 1, 2
    private scales = [1, 0.65, 0.42];
    private offsets = [0, 0.95, 1.5]; // multiples of `size`

    isVisible(i: number): boolean {
        return Math.abs(i - this.active) <= 2;
    }

    cardStyle(i: number) {
        const d = i - this.active;
        const abs = Math.min(Math.abs(d), 2);
        const px = this.size * this.scales[abs];
        const x = Math.sign(d) * this.size * this.offsets[abs];
        return {
            width: px + "px",
            height: px + "px",
            transform: `translate(calc(-50% + ${x}px), -50%)`,
            opacity: this.isVisible(i) ? 1 : 0,
            zIndex: 10 - Math.abs(d),
        };
    }

    // vertical centre of the stage = vertical centre of every card
    get arrowTop(): number {
        return this.size / 2;
    }

    get nextArrowStyle() {
        return {
            left: `calc(50% + ${this.size * this.offsets[1]}px)`,
            top: this.arrowTop + "px",
        };
    }

    get prevArrowStyle() {
        return {
            left: `calc(50% - ${this.size * this.offsets[1]}px)`,
            top: this.arrowTop + "px",
        };
    }

    @Prop({ default: 0 }) value!: number;   // the active index, owned by the store

    get active(): number {
        return this.value;
    }

    get activeItem(): ExpModel | undefined {
        return this.items[this.active];
    }

    select(i: number) {
        if (i < 0 || i >= this.items.length || i === this.value) return;
        this.$emit("input", i);
        this.$emit("select", this.items[i]);
    }
}
